<template>
  <div v-if="courseShow" class="full-reduction-pop">
    <div class="contentPop">
      <img
        @click="onClose"
        class="closed"
        src="https://iqh-zt-pord-cdn.iqihang.com/xunbao/closed.png"
        alt=""
      />
      <img class="success" src="https://iqh-zt-pord-cdn.iqihang.com/xunbao/success.png" alt="" />
      <h3>激活成功！</h3>
      <div class="checkbtn" v-if="subCatalogId" @click="myCourse">查看课程</div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    courseShow:Boolean,
    subCatalogId:String
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
    //跳转导学页
    myCourse() {
      if (this.$root.$data.isApp) {
        this.$sendToApp('goDirectoryPage', { courseId: this.subCatalogId*1 }, false);
      } else {
        this.$router.push({
          path: '/learningGuide',
          query: { catalogId: this.subCatalogId*1 },
        });
      }
    },
    onClose() {
      this.$emit('courseChangeShow');
    },
  },
};
</script>
<style scoped lang="scss">
.full-reduction-pop {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  .contentPop {
    position: relative;
    width: 654px;
    height: 430px;
    background: #ffffff;
    border-radius: 16px;
    margin: 0 auto;
    top: 50%;
    transform: translateY(-50%);
    padding-top: 80px;
    .closed {
      position: absolute;
      right: 30px;
      top: 30px;
    }
    .success {
      display: block;
      width: 96px;
      height: 96px;
      margin: 0 auto;
    }
    h3 {
      font-size: 28px;
      font-weight: 400;
      color: #000000;
      text-align: center;
      margin: 44px 0;
    }
    .checkbtn {
      width: 324px;
      height: 76px;
      line-height: 76px;
      background: #ff7f41;
      border-radius: 50px;
      margin: 0 auto;
      font-size: 32px;
      font-weight: 500;
      text-align: center;
      color: #ffffff;
    }
  }
}
</style>
